import { useCallback } from 'react';

import { useRenewSubscriptionWithNewCardMutation } from 'store/api/external-api.slice';
import { getSquareSuccessMessage } from 'utils';

import useDispatchMessage from './useDispatchMessage';

const useProcessSquarePayment = ({ renewInfo, setPaymentStatus, onComplete }) => {
	const [renewSubscriptionWithNewCard] = useRenewSubscriptionWithNewCardMutation();

	const dispatchMessage = useDispatchMessage();

	const handler = useCallback(
		async data => {
			try {
				const renewData = {
					...data,
					sourceId: data.nonce,
					mc_form_token: renewInfo.form_token,
					mc_uid: renewInfo.user.id,
					mc_redirect: false
				};

				const formData = new FormData();

				Object.keys(renewData).forEach(key => {
					formData.append(key, renewData[key]);
				});

				const result = await renewSubscriptionWithNewCard(formData);

				if (result.data?.result?.status === 'COMPLETED') {
					const message = getSquareSuccessMessage(result.data.result);

					dispatchMessage({
						message
					});
					setPaymentStatus('SUCCESS');
				} else {
					dispatchMessage({
						message: 'Payment Failed! Please, try again later',
						variant: 'error'
					});
					setPaymentStatus('ERROR');
				}
			} catch (e) {
				const message = e?.detail.includes('INVALID_CARD_DATA')
					? 'Payment Failed! Something wrong with your card data. Please, try again'
					: 'Payment Failed! Please, try again later';
				dispatchMessage({
					message,
					variant: 'error'
				});
				setPaymentStatus('ERROR');
			} finally {
				onComplete?.();
			}
		},
		[
			onComplete,
			renewInfo.form_token,
			renewInfo.user?.id,
			renewSubscriptionWithNewCard,
			dispatchMessage,
			setPaymentStatus
		]
	);

	return handler;
};

export default useProcessSquarePayment;
